import { InputInfoLabelSubTitle, InputInfoLabelTitle } from 'pages/NotificationTreatment/NotificationsTreatmentsSteps/NotificationData/styles'
import React from 'react'

interface LabelsForInputProps {
  title: string
  subtitle?: string
  styles?: {
    containerStyle?:string
    titleStyle?: string
    subtitleStyle?:string
  }
}
const LabelsForInput: React.FC<LabelsForInputProps> = ({ title, subtitle ,styles}) => {
  return (
      <div className={`mb-1 ${styles?.containerStyle}`}>
          <InputInfoLabelTitle className={`${styles?.titleStyle}`}>{title}</InputInfoLabelTitle>

          <InputInfoLabelSubTitle className={`${styles?.subtitleStyle}`}>{subtitle}</InputInfoLabelSubTitle>
      </div>
  )
}

export { LabelsForInput }